import { httpClient } from 'shared/services/http/httpClient';
import {
  BusinessSector,
  SectorPayloadToCreate
} from '../models/businessSectors';

export const businessSectorsService = () => {
  const getSectors = async (): Promise<BusinessSector[]> => {
    const res = await httpClient.get('sectors');
    return res;
  };

  const addSector = async (values: SectorPayloadToCreate) => {
    const res = await httpClient.post('sectors', values);
    return res;
  };

  const editSector = async (id: number, values: SectorPayloadToCreate) => {
    const res = await httpClient.put(`sectors/${id}`, values);
    return res;
  };

  const deleteSector = async (id: number) => {
    const res = await httpClient.delete(`sectors/${id}`);
    return res;
  };

  return {
    getSectors,
    addSector,
    editSector,
    deleteSector
  };
};
